/* KPharmacy — Supplement Finder (Shopify Storefront engine) */
!function(){
  "use strict";
  var $=function(s,r){return (r||document).querySelector(s);};
  var $$=function(s,r){return [].slice.call((r||document).querySelectorAll(s));};
  var UTM="utm_source=zenbundle&utm_medium=supplementfinder&utm_campaign=supplement_finder";
  function utm(u){if(!u||u==="#")return u;return u+(u.indexOf("?")>-1?"&":"?")+UTM;}
  function esc(s){var d=document.createElement("div");d.textContent=s==null?"":s;return d.innerHTML;}
  function track(e,d){try{window.zenbundle&&window.zenbundle.eventDispatcher&&window.zenbundle.eventDispatcher.logCustomEvent&&window.zenbundle.eventDispatcher.logCustomEvent(e,d||{});}catch(x){}}

  var cfg,steps,cur,sel,curPref;
  var quiz,nav,btnBack,btnNext,btnRes,btnRestart,fill,pSteps,results,grid,count,empty,loading;

  function init(){
    var c=$("#ksf-config"); if(!c)return console.error("[Supplement Finder] no config");
    cfg=JSON.parse(c.textContent); steps=cfg.steps; cur=0; sel={};
    quiz=$("#ksf-quiz");nav=$("#ksf-nav");btnBack=$("#ksf-back");btnNext=$("#ksf-next");
    btnRes=$("#ksf-show-results");btnRestart=$("#ksf-restart");fill=$("#ksf-progress-fill");
    pSteps=$("#ksf-progress-steps");results=$("#ksf-results");grid=$("#ksf-results-grid");
    count=$("#ksf-results-count");empty=$("#ksf-results-empty");loading=$("#ksf-loading");
    pSteps.innerHTML=steps.map(function(s,i){return '<button class="ksf-progress__step" data-step="'+i+'"><span class="ksf-progress__dot"></span><span class="ksf-progress__label">'+esc(s.id)+'</span></button>';}).join("");
    $$(".ksf-progress__step",pSteps).forEach(function(b){b.addEventListener("click",function(){var i=parseInt(this.dataset.step,10);if(i<cur)go(i);});});
    btnBack.addEventListener("click",function(){if(cur>0)go(cur-1);});
    btnNext.addEventListener("click",function(){if(cur<steps.length-1)go(cur+1);});
    btnRes.addEventListener("click",showResults);
    btnRestart.addEventListener("click",function(){sel={};go(0);});
    render(0);track("SupplementFinder_Started");
  }

  function render(i){
    cur=i;var st=steps[i],chosen=sel[st.id]||[];
    quiz.innerHTML='<div class="ksf-step"><h2 class="ksf-step__question">'+esc(st.question)+'</h2><p class="ksf-step__subtitle">'+esc(st.subtitle||"")+'</p><div class="ksf-options">'+
      st.options.map(function(o,oi){return '<button class="ksf-option'+(chosen.indexOf(oi)>-1?" ksf-option--selected":"")+'" data-index="'+oi+'" type="button"><span class="ksf-option__icon">'+(o.icon||"")+'</span><span class="ksf-option__label">'+esc(o.label)+'</span></button>';}).join("")+'</div></div>';
    $$(".ksf-option",quiz).forEach(function(b){b.addEventListener("click",function(){choose(st,b);});});
    fill.style.width=((i+1)/steps.length*100)+"%";
    $$(".ksf-progress__step",pSteps).forEach(function(b,bi){b.classList.toggle("ksf-progress__step--active",bi===i);b.classList.toggle("ksf-progress__step--done",bi<i);b.classList.toggle("ksf-progress__step--clickable",bi<i);});
    updateNav();
    quiz.style.display="";nav.style.display="";results.style.display="none";loading.style.display="none";
  }

  function go(i){render(i);setTimeout(function(){try{var y=quiz.getBoundingClientRect().top+window.pageYOffset-120;window.scrollTo({top:Math.max(0,y),behavior:"smooth"});}catch(e){}},60);}

  function choose(st,btn){
    var idx=parseInt(btn.dataset.index,10);
    if(st.multiSelect){
      btn.classList.toggle("ksf-option--selected");var s=sel[st.id]||[];var p=s.indexOf(idx);
      if(p>-1)s.splice(p,1);else s.push(idx);sel[st.id]=s;
    }else{
      $$(".ksf-option",quiz).forEach(function(b){b.classList.remove("ksf-option--selected");});
      btn.classList.add("ksf-option--selected");sel[st.id]=[idx];
    }
    updateNav();
    if(!st.multiSelect){var t=(btnRes&&btnRes.style.display!=="none")?btnRes:((btnNext&&btnNext.style.display!=="none")?btnNext:nav);if(t)setTimeout(function(){try{t.scrollIntoView({behavior:"smooth",block:"center"});}catch(e){}},60);}
  }

  function updateNav(){
    var has=sel[steps[cur].id]&&sel[steps[cur].id].length>0;
    var first=cur===0,last=cur===steps.length-1;var optional=!!steps[cur].optional;
    btnBack.style.display=first?"none":"";
    btnNext.style.display=last?"none":"";btnNext.disabled=!(has||optional);
    btnRes.style.display=last?"":"none";btnRes.disabled=!(has||optional);
    btnRestart.style.display="none";
  }

  /* ---- Supplement query model ----
     Each option may carry a `q` storefront clause fragment (double-quoted tag/vendor/title).
     Roles: audience (soft lens), goal (core, required), format (boost), extras (multi boost).
     Clauses AND-join; a fallback chain drops the soft clauses first so results are never empty.
     Every query excludes OTC medication via cfg.exclude. */
  function clauseFor(role){
    var st=steps.find(function(x){return x.role===role;});if(!st)return null;
    var c=sel[st.id]||[];if(!c.length)return null;
    if(st.multiSelect){
      var qs=c.map(function(i){return st.options[i].q;}).filter(Boolean);
      return qs.length?"("+qs.join(" AND ")+")":null;
    }
    var q=st.options[c[0]].q;return q||null;
  }

  function build(parts){
    var b=parts.filter(Boolean).join(" AND ");
    if(cfg.exclude)return b?b+" AND "+cfg.exclude:cfg.exclude;
    return b;
  }

  /* Audience is a soft lens: it's a hard clause in the first attempt, but the fallback
     can drop it — so we ALSO re-rank results client-side to float gender-matched products
     up and push opposite-gender-specific products down, preserving best-selling order within
     each group. This is what keeps "Men + Pregnancy" showing the men's product first. */
  function audiencePref(){var s=steps.find(function(x){return x.role==="audience";});if(!s)return null;var c=sel[s.id]||[];return c.length?(s.options[c[0]].pref||null):null;}
  function genderOf(p){
    var t=((p.title||"")+" "+(p.vendor||"")).toLowerCase();
    var tags=(p.tags||[]).map(function(x){return x.toLowerCase();});
    var w=/\b(women|woman|female|menopaus|meno|pregnan|conception|prenatal|maternity|folic|evening primrose|p\.?m\.?t|hormonal|menomin)\b/.test(t)||tags.indexOf("women's health")>-1||tags.indexOf("mum to be")>-1||tags.indexOf("menopause")>-1;
    var m=/\b(men|man|male|prostate|wellman|testo|saw palmetto)\b/.test(t)||tags.indexOf("mens")>-1;
    if(m&&!w)return "M";if(w&&!m)return "W";if(w&&m)return "X";return "U";
  }
  function genderScore(p){var g=genderOf(p);
    if(curPref==="M")return g==="M"?2:(g==="W"?-3:0);
    if(curPref==="W")return g==="W"?2:(g==="M"?-3:0);
    return 0;}
  function rankByAudience(prods){
    if(!curPref)return prods;
    return prods.map(function(p,i){return {p:p,i:i,s:genderScore(p)};})
      .sort(function(a,b){return (b.s-a.s)||(a.i-b.i);})
      .map(function(o){return o.p;});
  }

  function showResults(){
    quiz.style.display="none";nav.style.display="none";loading.style.display="";results.style.display="none";
    track("SupplementFinder_Completed");
    curPref=audiencePref();
    /* Audience is NOT a hard query clause — it would narrow the goal (e.g. Women + Menopause
       to the tiny intersection). Instead the goal defines breadth and curPref re-ranks. */
    var goal=clauseFor("goal"),format=clauseFor("format"),extras=clauseFor("extras");
    var attempts=[
      build([goal,format,extras]),
      build([goal,format]),
      build([goal])
    ].filter(function(v,i,a){return v && a.indexOf(v)===i;});
    runChain(attempts,0,false);
  }

  function runChain(attempts,i,isFallback){
    if(i>=attempts.length){renderResults([],true);return;}
    queryStore(attempts[i]).then(function(prods){
      if(prods.length)renderResults(prods,isFallback||i>0);
      else runChain(attempts,i+1,true);
    });
  }

  function queryStore(q){
    var sf=cfg.storefront,ep="https://"+sf.domain+"/api/"+(sf.apiVersion||"2024-07")+"/graphql.json";
    var gql='query($q:String!,$n:Int!){products(first:$n,query:$q,sortKey:BEST_SELLING){edges{node{title vendor tags handle onlineStoreUrl featuredImage{url} priceRange{minVariantPrice{amount currencyCode}} compareAtPriceRange{minVariantPrice{amount}}}}}}';
    return fetch(ep,{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":sf.token},body:JSON.stringify({query:gql,variables:{q:q,n:cfg.maxResults||24}})})
      .then(function(r){return r.json();})
      .then(function(d){return ((d.data&&d.data.products&&d.data.products.edges)||[]).map(function(e){return e.node;});})
      .catch(function(e){console.error("[Supplement Finder]",e);return [];});
  }

  function money(v,cur){var n=parseFloat(v);var sym=cur==="EUR"?"€":(cur==="GBP"?"£":"$");return sym+(isNaN(n)?v:n.toFixed(2));}

  function renderResults(prods,isFallback){
    loading.style.display="none";results.style.display="";btnRestart.style.display="";nav.style.display="";
    btnBack.style.display="none";btnNext.style.display="none";btnRes.style.display="none";
    if(!prods.length){grid.innerHTML="";empty.style.display="";count.textContent="";var ir=$("#ksf-restart-inline");if(ir)ir.addEventListener("click",function(){sel={};go(0);});return;}
    empty.style.display="none";
    prods=rankByAudience(prods);
    count.textContent=(isFallback?"Closest matches — ":"")+prods.length+" "+(prods.length===1?"product":"products")+" matched";
    track("SupplementFinder_ResultsViewed",{resultCount:prods.length,isFallback:!!isFallback});
    var cta=(cfg.labels&&cfg.labels.cta)||"Shop Now";
    grid.innerHTML=prods.map(function(p,i){
      var url=p.onlineStoreUrl||("https://"+cfg.storefront.domain+"/products/"+p.handle);
      var img=p.featuredImage?p.featuredImage.url:"";
      var price=p.priceRange&&p.priceRange.minVariantPrice?money(p.priceRange.minVariantPrice.amount,p.priceRange.minVariantPrice.currencyCode):"";
      var cmp=p.compareAtPriceRange&&p.compareAtPriceRange.minVariantPrice&&parseFloat(p.compareAtPriceRange.minVariantPrice.amount)>parseFloat(p.priceRange.minVariantPrice.amount)?money(p.compareAtPriceRange.minVariantPrice.amount,p.priceRange.minVariantPrice.currencyCode):"";
      return '<a href="'+esc(utm(url))+'" class="ksf-product">'+(i<3?'<span class="ksf-product__badge">Best Match</span>':'')+
        '<div class="ksf-product__image">'+(img?'<img src="'+esc(img)+'" alt="'+esc(p.title)+'" loading="lazy">':'<div class="ksf-product__placeholder">No image</div>')+'</div>'+
        '<div class="ksf-product__info"><p class="ksf-product__vendor">'+esc(p.vendor||"")+'</p><h3 class="ksf-product__title">'+esc(p.title)+'</h3>'+
        '<p class="ksf-product__price">'+(cmp?'<s class="ksf-product__compare">'+cmp+'</s> '+price:price)+'</p>'+
        '<span class="ksf-product__cta">'+esc(cta)+'</span></div></a>';
    }).join("");
  }

  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init();
}();
